import React from "react";
import { useFlags } from "../../../../config/featureFlags";
import FooterLikumi from "./FooterLikumi";
import FooterCode from "./FooterCode";

export function Footer() {
  const { DISPLAY_CODE_CONTENT } = useFlags();

  return (
    (DISPLAY_CODE_CONTENT) ? <FooterCode/> : <FooterLikumi/>
  );
}
